import axios from 'axios';
import { spaceClient } from './client';
import { API_ROOT } from './apiConfig';

export const getSpaceById = () =>
  spaceClient.get('');

export const getMapSpots = () =>
  axios.get(`${API_ROOT}/mapspots`);

// Returns [{ id }] — the 22 global fixed teleport map slots (id 1–22)
export const getPositions = () =>
  axios.get(`${API_ROOT}/positions`).then((r) => r.data);

// Returns [{ localeId, displayName }] — display names sourced from i18n_locale table
export const getLocales = () =>
  spaceClient.get('/supported-languages').then((r) => r.data);

export const getNextMapSpotId = () =>
  axios.get(`${API_ROOT}/mapspots/next-id`);

export const updateSpace = (data) =>
  spaceClient.put('', data);
